import React, { useState } from "react";
import DropdownPortal from "./common/DropdownPortal";
import { useSelector } from "react-redux";
import { arClass } from "../utils/useArClass";
import RoleBadge from "./RoleBadge";







/**
 * 
 * @styles:
 * default:bg+border+text-color
 * bg-text:bg+no border+text-color
 * text-only:bg-transparent+no border+text-color
 * @returns 
 */
const RoleListPreview = ({
  roles = [],
  style = "default",
  paddingY,
  paddingX,
  fontSize,
  smFontSize,
  my = "my-2",
  shortTheVisibleRoles = false,
  lengthOfVCIVR = 5,
}) => {
  
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const darkMode = useSelector((state) => state.settings.darkMode);

  if (!roles.length) return null;

  const visibleRoles = roles.slice(0, 1);
  const remainingCount = roles.length - visibleRoles.length;

  return (
    <span className={arClass(`inline-flex items-center gap-1 ${my}`)}>
      {visibleRoles.map((roleName, index) => (
        <React.Fragment key={`${roleName}-${index}`}>
          {index > 0 ? ", " : ""}
          <RoleBadge
            role={roleName}
            style={style}
            paddingY={paddingY}
            paddingX={paddingX}
            fontSize={fontSize}
            smFontSize={smFontSize}
            shortTheVisibleRoles={shortTheVisibleRoles}
            lengthOfVCIVR ={lengthOfVCIVR}
          />
        </React.Fragment>
      ))}
      {remainingCount > 0 && (
        <span
          className={arClass("relative")}
          onMouseEnter={(event) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
            setIsOpen(true);
          }}
          onMouseLeave={() => {
            setIsOpen(false);
            setAnchorEl(null);
          }}
        >
          <span
            className={arClass(`${
              fontSize || "text-sm"
            } underline decoration-dotted cursor-pointer`,
            )}
            aria-expanded={isOpen}
          >
            +{remainingCount}
          </span>
          {isOpen && anchorEl && (
            <DropdownPortal
              anchorRef={{ current: anchorEl }}
              onClose={() => {
                setIsOpen(false);
                setAnchorEl(null);
              }}
              className="!w-max  "
            >
              <div className={arClass("p-2")}>
                {roles.map((roleName, index) => (
                  <div
                    key={`${roleName}-full-${index}`}
                    className={arClass(
                      `px-2 py-1 rounded text-xs w-full ${
                        darkMode
                          ? "text-gray-200 hover:bg-gray-700"
                          : "text-gray-700 hover:bg-gray-100"
                      }`,
                    )}
                  >
                    <RoleBadge
                    
                      role={roleName}
                      style={style}
                      paddingY={paddingY}
                      fontSize={fontSize}
                      smFontSize={smFontSize}
                    />
                  </div>
                ))}
              </div>
            </DropdownPortal>
          )}
        </span>
      )}
    </span>
  );
};

export default RoleListPreview;
